/* eslint-disable import/no-duplicates */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable radix */
/* eslint-disable indent */
import { format, parse, isValid } from 'date-fns';
import { enUS, es, ptBR } from 'date-fns/locale';
import i18n from 'i18n';
import moment from 'moment';
import { Base64 } from 'js-base64';
import _ from 'lodash';

export const types = {
  object: '[object Object]',
  array: '[object Array]',
  string: '[object String]',
  boolean: '[object Boolean]',
  number: '[object Number]',
};

export const getType = prop => Object.prototype.toString.call(prop);

export const isObject = maybeAnObject =>
  getType(maybeAnObject) === types.object;

export const unMask = value => value.replace(/[^0-9]+/g, '');

export const removeSpaces = stringValue => stringValue.replace(/\s/g, '');

export const cleanObject = objs => objs.map(obj => obj.value);

export const randColor = () =>
  `#${Math.floor(Math.random() * 16777215).toString(16)}`;

export const promisify = func => (...args) =>
  new Promise((resolve, reject) =>
    func(...args, (err, result) => (err ? reject(err) : resolve(result)))
  );

export const roundToFixedTwoWithPercentage = item =>
  `${(Math.round(item * 100) / 100).toFixed(2)}%`;

export const roundToFixedTwo = item =>
  (Math.round(item * 100) / 100).toFixed(2);

export const capitalizeString = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

const suffixes = ['REQUEST', 'FULFILLED', 'REJECTED'];

export const getTypes = type =>
  suffixes.reduce(
    (acc, curr) => ({ ...acc, [`${type}_${curr}`]: `${type}_${curr}` }),
    {}
  );

export const isEmptyObj = (obj = {}) =>
  Object.values(obj).filter(Boolean).length === 0;

export const mapDispatchToProps = actions => dispatch => ({
  actions: Object.entries(actions).reduce(
    (acc, [actionName, action]) => ({
      ...acc,
      [actionName]: (...args) => dispatch(action(...args)),
    }),
    {}
  ),
});

function* getColor(colors, reset = 0) {
  let index = reset;
  while (true) {
    yield colors[index];
    index = (index + 1) % colors.length;
  }
}
export const colorGen = (colors = []) => getColor(colors);

export const isRequestOK = status =>
  [200, 201, 202, 204, 208, 300].includes(status);

export const formValidation = {
  isRequired: (field, value) => !value && { [field]: 'campo obrigatório' },
  length: (field, value, length, message) =>
    value.length !== length && {
      [field]: message || `${field} deve conter ${length} caracteres`,
    },
};

export const replaceAllButDigits = (stringValue = '') =>
  stringValue.replace(/[^0-9.]/g, '');
export const replaceAllButDigitsWithoutPoint = (stringValue = '') =>
  stringValue.replace(/[^0-9]/g, '');

export const alphabeticalSortByProp = prop => (a, b) => {
  if (a[prop] < b[prop]) return -1;
  if (a[prop] > b[prop]) return 1;
  return 0;
};

export const flattenObject = (myObk, context = '') =>
  Object.keys(myObk).reduce(
    (acc, current) =>
      isObject(myObk[current])
        ? { ...acc, ...flattenObject(myObk[current], current) }
        : {
            ...acc,
            [context ? `${context}.${current}` : current]: myObk[current],
          },
    {}
  );

export const alphabeticalSortArray = array =>
  array.sort((a, b) => {
    return a.firstname.localeCompare(b.firstname);
  });

export const filterNonEmptyKeys = obj =>
  Object.keys(obj).reduce(
    (acc, current) =>
      obj[current] ? { ...acc } : { ...acc, [current]: obj[current] },
    {}
  );

const filterObjectHelper = obj => Object.keys(obj).filter(key => !obj[key]);

export const filterObject = (obj, msg = '') => {
  const filteredObjectedKeys = filterObjectHelper(obj);
  return filteredObjectedKeys.reduce(
    (acc, current) => ({ ...acc, [current]: msg }),
    {}
  );
};

export const filterObjectByKey = (obj, key) =>
  Object.keys(obj).reduce(
    (acc, current) =>
      current === key ? { ...acc } : { ...acc, [current]: obj[current] },
    {}
  );

export const isANumberValue = value => /^\d*$/.test(value);

export const objHasProp = (obj, prop) =>
  obj && Object.prototype.hasOwnProperty.call(obj, prop);

export const findValueByPropName = (array, prop, name) =>
  array.find(item => item.name === name)[prop];

export const parseJwt = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(Base64.decode(base64));
};

export const formatCurrency = number =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    number
  );

export const formatCNPJ = cnpj => {
  const string = cnpj?.toString() || '';

  return `${string.substr(0, 2)}.${string.substr(2, 3)}.${string.substr(
    5,
    3
  )}/${string.substr(8, 4)}-${string.substr(12, 2)}`;
};

export const formatCPF = cpf => {
  let string = cpf?.toString() || '';
  if (string.length > 11) {
    string = string.replace(/[^\w\s]/gi, '');
  }

  return `${string.substr(0, 3)}.${string.substr(3, 3)}.${string.substr(
    6,
    3
  )}-${string.substr(9, 2)}`;
};

export const validateCpf = cpfString => {
  if (!cpfString) return false;

  const cpf = cpfString.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i += 1) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i += 1) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10))) return false;
  return true;
};

export const regexExp = {
  phone: /^[(](\d{2})[)]\D*(\d{5}|\d{4})[-]\D*(\d{4})$|^[(](\d{2})[)]\D*(\d{5})[-]\D*(\d{3})$|^[(](\d{2})[)]\D*(\d{4})[-]\D*(\d{5})$/,
  lettersOnly: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
  numbersOnly: /^\d+$/,
  numbersAndDotsOnly: /^\d+(\.\d+)*$/,
  numbersDotsBarsOnly: /^\d+(\.\d+)|(\/\d+)*$/,
  ipNumber: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
  ipNumberWithSlash: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(\/\d{1,2})?$/,
  // eslint-disable-next-line no-useless-escape
  isEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  notAcceptAtSign: /^[^@]*$/,
  subdomain: /^[a-z]([a-z0-9]*-?[a-z0-9]+)*$/,
  domain: /^(?!.*--)(?=.+\.[a-z0-9-]{2,}$)[a-z][a-z0-9.-]*[a-z0-9]$/,
};

export const objToArray = obj => {
  if (!obj) return [];
  return Object.keys(obj).map(key => obj[key]);
};

export const objToQueryString = obj => {
  if (!obj) return '';

  const queryParams = { ...obj };

  if (obj.filters && typeof obj.filters === 'object') {
    Object.keys(obj.filters).forEach(key => {
      queryParams[key] = obj.filters[key];
    });

    delete queryParams.filters;
  }

  return Object.keys(queryParams)
    .filter(key => queryParams[key] !== '' && queryParams[key] !== null)
    .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join('&');
};

export const formatDate = (date, formatString = 'Y-LL-dd') => {
  return format(date, formatString);
};

export const formatDateToISO = date => moment(date).toISOString(true);

export const adjustDateByTwoHours = dateString => {
  if (String(dateString) !== 'Invalid Date') {
    const date = new Date(dateString || '2022-03-18T23:59:59');

    date.setTime(date.getTime());

    const offset = -3 * 60;
    const offsetMilliseconds = offset * 60 * 1000;
    const localDate = new Date(date.getTime() + offsetMilliseconds);

    const adjustedDateString = localDate.toISOString().replace('Z', '-03:00');

    return adjustedDateString;
  }
  return new Date();
};

export const formatIsoDateToTimeDate = value => {
  if (!value) return null;

  const year = value.slice(0, 4);
  const month = value.slice(5, 7);
  const day = value.slice(8, 10);
  const time = value.slice(11, 16);

  return `${time} - ${day}-${month}-${year}`;
};

export const formatHour = (value, formatString = 'HH:mm') => {
  try {
    return format(value, formatString);
  } catch (error) {
    return '';
  }
};

export const formatHourMinute = dataString => {
  const data = new Date(dataString);
  return data.toTimeString().slice(0, 5);
};

export const formatHourMinuteSecond = value => {
  if (value == null || value === '') return '-';

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleTimeString('pt-BR', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

export const parseHour = (value, formatString = 'HH:mm') => {
  if (value) {
    return parse(value, formatString, new Date());
  }
  return new Date();
};

export const isString = value => {
  if (typeof value === typeof '') {
    return true;
  }
  return false;
};

export const formatModelName = (name, description) => {
  return `${name} | ${description}`;
};

export const getTimesUrl = urls => {
  if (urls !== undefined) {
    if (urls.length !== 0) {
      const begin = urls.map(item =>
        item.split('/dashboard/chart/session/data/?begin_time=')
      );
      const times = begin.map(item => item[1].split('2&end_time='));

      return {
        begin_time: times[0][0],
        end_time: times[1][0],
      };
    }
  }
  return {
    begin_time: '',
    end_time: '',
  };
};

export const formatTimeStamp = timestamp => {
  const time = new Date(timestamp);

  return `${time.getHours()}:${time.getMinutes()}`;
};

export const formatDataToChart = data => {
  try {
    const values = [];
    const aux = [];
    for (let index = 0; index < data.length; index++) {
      values.push(data[index].data);
    }

    const [maxSession, maxVacancies, totalLicenses] = values;
    for (let index = 0; index < values.length; index++) {
      aux.push(
        maxSession[index].concat(
          maxVacancies[index][1],
          totalLicenses[index][1]
        )
      );
    }
    return aux.map(item => ({
      name: formatTimeStamp(item[0]),
      activeSessions: item[1],
      vacanciesSessions: item[2],
      totalLicenses: item[3],
    }));
  } catch (error) {
    return [
      {
        name: '00:00',
        activeSessions: 0,
        totalLicenses: 0,
      },
    ];
  }
};

export const formatDataInstanceToChart = data => {
  try {
    const values = [];
    const aux = [];

    for (let index = 0; index < data.length; index++) {
      values.push(data[index].data);
    }

    const [total, operational, occupied, blocked, unavailable] = values;
    for (let index = 0; index < values.length - 1; index++) {
      aux.push(
        total[index].concat(
          operational[index][1],
          occupied[index][1],
          blocked[index][1],
          unavailable[index][1]
        )
      );
    }

    return aux.map(item => ({
      name: formatTimeStamp(item[0]),
      total: item[1],
      operational: item[2],
      occupied: item[3],
      blocked: item[4],
      unavailable: item[5],
    }));
  } catch (error) {
    return [
      {
        name: '00:00',
        total: 0,
        operational: 0,
        occupied: 0,
        blocked: 0,
        unavailable: 0,
      },
    ];
  }
};
export const formatDateWithMoment = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .local()
    .format('DD/MM/YYYY HH:mm');
};
export const formatDateDayMonth = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .local()
    .format('DD/MM HH:mm');
};

export const formatDateWithMomentNoTime = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .local()
    .format('DD/MM/YYYY');
};

export const formatDateForEnvStatus = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .add(1, 'd')
    .local()
    .format('YYYY/MM/DD');
};

export const formatDateForEnvStatusForApprove = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .add(1, 'd')
    .local()
    .format('DD/MM/YYYY');
};

export const formatDateForEnvStatusUpdate = date => {
  if (!date) return '-';

  return moment(new Date(date))
    .local()
    .format('YYYY-MM-DD');
};

export const dateFormatWithAt = date =>
  moment(new Date(date))
    .local()
    .format(
      i18n.language === 'en-US'
        ? `MM/DD/YYYY [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] hh:mm`
        : `DD/MM/YYYY [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] HH:mm`
    );

export const dateFormatWithAtDayMonth = date =>
  moment(new Date(date))
    .local()
    .format(
      i18n.language === 'en-US'
        ? `MM/DD [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] hh:mm`
        : `DD/MM [${i18n.t('AUDIT_SESSION.TIME_AT_KEY')}] HH:mm`
    );

export const clearingEmptyFieldsObject = values =>
  _.pickBy(values, value => !(value === null || value === ''));

export const removeFields = (blacklist, fields) =>
  fields.filter(field => !blacklist.includes(field.stateKey));

export const getErrorMessageKey = error => {
  let messageKey = 'UNEXPECTED_ERROR';

  if (error?.response?.data?.message?.code) {
    messageKey = error.response.data.message.code.toUpperCase();
  }

  return messageKey;
};

export const getErrorsFields = error => {
  if (error?.response?.data?.errors) {
    return error?.response?.data?.errors;
  }
  return null;
};

export const shortString = (str, maxLength = 100) => {
  const isString = typeof str === typeof '';

  if (isString && str.length > maxLength) {
    return `${str.substring(0, maxLength)}...`;
  }

  return str;
};

export const parseNameLdap = name => {
  const namesLdap = {
    internal: i18n.t('INTERNAL_KEY'),
    external: i18n.t('EXTERNAL_KEY'),
    managed: i18n.t('MANAGED_KEY'),
  };
  return namesLdap[name] || name;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const applyI18n = (fields, _) =>
  fields.map(field => ({
    ...field,
    label: i18n.t(field.label),
    placeholder: i18n.t(field.placeholder),
    options: field.options?.map(option => ({
      ...option,
      label: i18n.t(option.label),
    })),
    radioGroupOptions: field.radioGroupOptions?.map(option => ({
      ...option,
      label: i18n.t(option.label),
    })),
  }));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const i18nReload = (key, adornment, _) => {
  return `${i18n.t(key)} ${adornment}`;
};

export const localeDictionary = {
  'pt-BR': ptBR,
  'en-US': enUS,
  es,
};

export const getLocaleDate = date => {
  try {
    const dateInIso = new Date(date);

    return format(
      dateInIso,
      `d '${i18n.t('OF_DAY_KEY')}' MMMM, Y '${i18n.t('AT_HOUR_KEY')}' HH:mm`,
      {
        locale: localeDictionary[i18n.language],
      }
    );
  } catch (error) {
    return date;
  }
};

export const formatDateToYearMouthDay = (date, toEmpty = false) => {
  if (toEmpty) {
    if (!date) return null;

    return date.toISOString().split('T')[0];
  }
  if (!date) return new Date().toISOString().split('T')[0];

  return date.toISOString().split('T')[0];
};

export const manipulateLocalStorage = (key, value) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
    return;
  }
  const item = localStorage.getItem(key);
  // eslint-disable-next-line consistent-return
  return JSON.parse(item);
};

export const formatPercent = value => {
  return `${Math.round(value * 100) / 100}%`;
};

export const formatPercentRounded = value => {
  return `${Math.round(value)}%`;
};

export const controlNumberLimits = (value, control) => {
  const formatValue = Math.max(
    control?.min || 0,
    Math.min(control?.max || 100, Number(value))
  );
  return formatValue;
};

export const controlMaxAndMinValues = (value, control) => {
  const formatValue = Math.max(
    control?.min || 0,
    Math.min(control?.max || 100, Number(value))
  );
  if (formatValue === 0) {
    return String(formatValue);
  }
  return formatValue;
};

export const exportFileCsv = (header, data) => {
  const rows = [header, data];

  let csvContent = 'data:text/csv;charset=utf-8,';
  rows.forEach(rowArray => {
    const row = rowArray.join(',');
    csvContent += `${row}\r\n`;
  });

  const encodedUri = encodeURI(csvContent);

  window.open(encodedUri);
};

export const numberWithDots = value => {
  return value.toString().replace(/(.)(?=(.{3})+$)/g, '$1.');
};

export const superUser = role =>
  role === 'superadmin' || role === 'admin' || role === 'operator';

export const privacyLink = {
  'pt-BR': 'https://skyone.solutions/juridico-e-grc/politica-de-privacidade/',
  'en-US': 'https://skyone.solutions/en/legal-and-grc/privacy-policy/',
  es: 'https://skyone.solutions/es/legal-y-grc/politica-de-privacidad/',
};

export const ethicsLink = {
  'pt-BR': 'https://skyone.solutions/juridico-e-grc/codigo-de-etica-e-conduta/',
  'en-US':
    'https://skyone.solutions/en/legal-and-grc/code-of-ethics-and-conduct/',
  es: 'https://skyone.solutions/es/legal-y-grc/codigo-de-etica-y-conducta/',
};

export const isDeepEqual = (object1, object2) => {
  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);

  if (objKeys1.length !== objKeys2.length) return false;

  let response = true;

  // eslint-disable-next-line no-unused-expressions
  objKeys1?.forEach(key => {
    const value1 = object1[key];
    const value2 = object2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if (
      (isObjects && !isDeepEqual(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      response = false;
    }
  });

  return response;
};

// Based on public https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
// Used for generating a unique value for components, based on response data.
/* Quote: "A fast and simple 53-bit string hash function with decent collision resistance.
Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity." */

/* eslint-disable no-bitwise */

/**
 * cyrb53Hash - CyRB53 Hashing Algorithm
 *
 * @summary _Hashes values to use the returned hash as unique keys for React components._
 * ---
 * @description The cyrb53Hash function is an implementation of the CyRB53 (Cyclic Redundancy Check with a 53-bit output) hashing algorithm.
 * It takes an input string and an optional seed value and returns a 53-bit hash value.
 *
 * Algorithm Steps:
 * 1. Initialize two 32-bit hash values, h1 and h2, with constants 0xdeadbeef and 0x41c6ce57 respectively, XORed with the seed value.
 * 2. For each character (ch) in the input string:
 *    a. Convert the character to its Unicode code point using str.charCodeAt(i).
 *    b. Mix the hash values h1 and h2 with the character code using the multiplication method (Math.imul) and bitwise XOR.
 * 3. Perform final mixing of h1 and h2 to improve the distribution of the hash:
 *    a. For h1: XOR it with its right-shifted value by 16 bits, then multiply with constant 2246822507 using Math.imul.
 *    b. For h2: XOR it with its right-shifted value by 13 bits, then multiply with constant 3266489909 using Math.imul.
 * 4. Return the final 53-bit hash value as a concatenation of (h2 & 2097151) and the upper 32 bits of h1.
 * ---
 * @param {string} str - The input string to be hashed.
 * @param {number} seed - Optional. A seed value to initialize the hash. Default is 0.
 * @returns {number} A 53-bit hash value.
 */
export const cyrb53Hash = (str, seed = 0) => {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str?.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
/* eslint-disable no-bitwise */

export const removeHTMLTags = str => {
  if (!str) return '-';
  return str
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export const isEmptyOrNull = value => value === null || value === '';

export const isValidTime = timeString => {
  const timeFormatRegex = /^([01]?\d|2[0-3]):([0-5]?\d)(:([0-5]?\d))?$/;

  if (!timeFormatRegex.test(timeString)) {
    return false;
  }

  const normalizedTimeString = timeString
    .split(':')
    .map(part => part.padStart(2, '0'))
    .join(':');

  const format = 'HH:mm:ss';

  const date = parse(normalizedTimeString, format, new Date());

  return isValid(date);
};

export const generateQueryString = fieldsArray => {
  return fieldsArray
    ?.filter(item => item?.isChecked && item?.value)
    ?.map(item => `${item?.key}=${item?.value}`)
    ?.join('&');
};

export const timeFormatter = (num, singular) => {
  return num > 0
    ? num + (num === 1 ? ` ${singular}, ` : ` ${singular}s, `)
    : '';
};
export const valueToDaysMinutesSeconds = totalSeconds => {
  const seconds = Math.floor(totalSeconds % 60);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const days = Math.floor(totalSeconds / (3600 * 24));

  const secondsStr = timeFormatter(seconds, i18n.t('INSTANCE_SECOND_KEY'));
  const minutesStr = timeFormatter(minutes, i18n.t('INSTANCE_MINUTE_KEY'));
  const hoursStr = timeFormatter(hours, i18n.t('INSTANCE_HOUR_KEY'));
  const daysStr = timeFormatter(days, i18n.t('INSTANCE_DAY_KEY'));

  return `${daysStr}${hoursStr}${minutesStr}${secondsStr}`.replace(/,\s*$/, '');
};

export const formatDuration = duration => {
  if (!duration) return '-';
  if (duration >= 60000) {
    const minutes = Math.floor(duration / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);
    return `${minutes}min ${seconds}s`;
  }
  if (duration >= 1000) {
    const seconds = Math.floor(duration / 1000);
    return `${seconds}s`;
  }
  return `${duration}ms`;
};

export const isValidUrl = url => {
  try {
    return Boolean(new URL(url));
  } catch (e) {
    return false;
  }
};

export const addThirtyDaysToMidnight = dateString => {
  const date = new Date(dateString);

  date.setDate(date.getDate() + 31);

  date.setHours(0, 0, 0, 0);

  return moment(new Date(date))
    .local()
    .format(
      i18n.language === 'en-US'
        ? `MM/DD [${i18n.t('AUDIT_SESSION.AT_KEY')}] hh:mm`
        : `DD/MM [${i18n.t('AUDIT_SESSION.AT_KEY')}] HH:mm`
    );
};
